import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
  Children,
} from 'react';
import axios from 'axios';
import { cloneElement } from 'react';
import { useI18n } from '@/hooks/useLocale';
import { useMountedState } from '@/hooks/useMountedState';
import { CommonConfirm, CommonForm } from '..';
import {
  Button,
  Card,
  Drawer,
  Modal,
  Notification,
  Spin,
  Tabs,
} from '@arco-design/web-react';
import { IconPoweroff, IconSave } from '@arco-design/web-react/icon';
import Draggable from 'react-draggable';
import { useSelector } from 'react-redux';
import { getClientHeight, getSettings } from '@/store/slices/appSlice';
import getUrlParams from '@/utils/getUrlParams';
import { findFormItem } from '@/utils/tools';
const TabPane = Tabs.TabPane;
export const LoongInCommonFormEdit = forwardRef(
  (
    {
      loading = false,
      children,
      panelTitle, //对话框标题
      title, //标题
      formItem, //表单项目定义
      initData, //初始化数据
      rules, //校验规则
      otherValidate, //其他校验方法
      createData, //创建数据的接口
      updateData, //更新数据的接口
      requestCreate, //
      requestUpdate, //
      forceUpdate = false, //提交时强制使用update
      getUpdateInput, //获取更新数据的入参
      getCreateInput, //获取创建数据的入参
      id, //Index传递过来的id
      formData, //index传递过来的数据
      onSubmit, //提交成功后
      onCancel, //取消后
      height, //第一个tab高度
      onTabChange, //页签切换、
      type, //类型: sidePanel: 抽屉(默认), dialog: 弹出对话框, div: 普通
      className, //css样式类
      resetAfterSumbit, //提交后是否重置表单
      showSaveButton, //显示保存按钮
      showCancelButton, //显示取消按钮
      onChange, //表单数据改变后触发事件
      onChangeBefore, //表单数据改变前触发事件
      width = 400, //sidePanel或dialog的宽度
      event, //
      disabled, //是否
      render, //渲染
      otherButtons, //其他按钮
      isQuickSave = true, //是否快速保存
      activeTabIndex, //
      showHead = true, //显示tab
      sizeClass = 'small', //'mini' | 'small' | 'default' | 'large'
      closeOnClickBackground = true, //点击背景后是否关闭
      escToExit = true, //Esc后关闭
      sumbitThenClose = true, //提交保存后关闭，默认：true 关闭
      keyField = 'id',
      layout = 'horizontal', //horizontal | vertical | inline
      labelCol,
      wrapperCol,
      formLayout, // = 'tabs', //表单显示模式: "tabs" | "card" ,默认:tabs
      draggable = false,
      isShowForm = true,
      formCardBtnLayout = 'footer',
      formCardBtnLayoutStyle = {},
      noRequest = false, // 提交不需要请求
      lazyLoad = true, //tabs不会在组件挂载的时候渲染被隐藏的标签页
      defaultMsgContent = true,
      bottomSlot = null, // 主tab底部插槽
      saveIcon = <IconSave />, //保存按钮图标
      saveText, //保存按钮文本
      returnText, //返回按钮文本,
      updateRequestType = 'put',
      showTitleType = true, //是否显示表单title的类型：添加/修改/查看
      saveTextCallback,
      formDisabled = false,
      canSaveDisabled = false,
      onClickSaveBefore,
      onClickSaveError,
      dynamicGetChildrenData = false, //动态获取子tab的数据
      mainDivIdField = 'main-form',
    },
    ref
  ) => {
    const urlParams = getUrlParams();
    const t = useI18n();
    const formRef = useRef(null);
    const [showSidePanel, setShowSidePanel] = useState(false);
    const [isSumbiting, setIsSumbiting] = useState(false);
    const [activeTab, setActiveTab] = useState('0');
    const [newFormData, setNewFormData] = useState(null);
    const isMounted = useMountedState();
    const [draggableDisabled, setDraggableDisabled] = useState(true);
    const clientHeight = useSelector(getClientHeight);
    const settings = useSelector(getSettings);
    const formShowTab = settings.formShowTab && urlParams.formShowTab !== false;
    const currentFormLayout = formLayout || (formShowTab ? 'tabs' : 'card');
    const [showExistConfirm, setShowExistConfirm] = useState(false);
    const createDataAsync = async (payload, btnText) => {
      onClickSaveBefore && (await onClickSaveBefore());
      setIsSumbiting(true);
      try {
        let response;
        if (!requestCreate) {
          response = await axios.post(createData(), payload);
        } else {
          if (noRequest) {
            requestCreate(
              payload,
              () => {
                Notification.success({
                  title: t('t_remind'),
                  content: btnText
                    ? btnText + t('common.success')
                    : t('t_successToAdd'),
                  showIcon: true,
                  position: 'bottomRight',
                  duration: 1500,
                });
                if (sumbitThenClose) setShowSidePanel(false);
                setIsSumbiting(false);
                resetForm();
              },
              () => {
                Notification.error({
                  title: t('t_remind'),
                  content: btnText
                    ? btnText + t('common.fail')
                    : t('t_failToAdd'),
                  showIcon: true,
                  position: 'bottomRight',
                  duration: 1500,
                });
                if (sumbitThenClose) setShowSidePanel(false);
                setIsSumbiting(false);
                resetForm();
              }
            );
            return;
          } else {
            response = await requestCreate(payload);
          }
        }
        if (!isMounted()) return;
        if (resetAfterSumbit === undefined || resetAfterSumbit === true)
          resetForm();
        onSubmit && (await onSubmit(response?.data, !sumbitThenClose, payload));
        Notification.success({
          title: t('t_remind'),
          content: btnText
            ? btnText + t('common.success')
            : t('t_successToAdd'),
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        });
        if (sumbitThenClose) setShowSidePanel(false);
      } catch (e) {
        onClickSaveError && onClickSaveError(e);
        Notification.error({
          title: t('t_remind'),
          content:
            e && e.error && e.error.message
              ? e.error.message
              : btnText
                ? btnText + t('common.fail')
                : t('t_failToAdd'),
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        });
      } finally {
        setIsSumbiting(false);
      }
    };
    const updateDataAsync = async (payload, btnText) => {
      onClickSaveBefore && (await onClickSaveBefore());
      setIsSumbiting(true);
      try {
        let response;
        if (!requestUpdate) {
          response = await axios[updateRequestType](
            updateData(payload[keyField]),
            payload
          );
        } else {
          if (noRequest) {
            await requestUpdate(
              payload,
              () => {
                Notification.success({
                  title: t('t_remind'),
                  content: btnText
                    ? btnText + t('common.success')
                    : t('t_successToUpdate'),
                  showIcon: true,
                  position: 'bottomRight',
                  duration: 1500,
                });
                if (sumbitThenClose) setShowSidePanel(false);
                setIsSumbiting(false);
                resetForm();
              },
              () => {
                Notification.error({
                  title: t('t_remind'),
                  content: btnText
                    ? btnText + t('common.fail')
                    : t('t_failToUpdate'),
                  showIcon: true,
                  position: 'bottomRight',
                  duration: 1500,
                });
                if (sumbitThenClose) setShowSidePanel(false);
                setIsSumbiting(false);
                resetForm();
              }
            );
            return;
          } else {
            response = await requestUpdate(payload);
          }
        }
        if (!isMounted()) return;
        if (resetAfterSumbit === undefined || resetAfterSumbit === true)
          resetForm();
        onSubmit && (await onSubmit(response?.data, !sumbitThenClose));
        Notification.success({
          title: t('t_remind'),
          content: btnText
            ? btnText + t('common.success')
            : t('t_successToUpdate'),
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        });
        if (sumbitThenClose) setShowSidePanel(false);
      } catch (e) {
        onClickSaveError && onClickSaveError(e);
        Notification.error({
          title: t('t_remind'),
          content:
            e && e.error && e.error.message
              ? e.error.message
              : btnText
                ? btnText + t('common.fail')
                : t('t_failToUpdate'),
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        });
      } finally {
        setIsSumbiting(false);
      }
    };
    const formatChildren = (children) => {
      let childrenData = {};
      children.map((item) => {
        let key = item.key;
        if (Array.isArray(item?.props?.children)) {
          item?.props?.children &&
            item?.props?.children.map((elem) => {
              let currKey = elem.key || key;
              if (currKey) {
                childrenData[currKey] = elem?.ref?.current?.getData?.() || null;
              }
            });
        } else {
          let currKey = item?.props?.key || key;
          if (currKey) {
            childrenData[key] = item?.ref?.current?.getData?.() || null;
          }
        }
      });
      return childrenData;
    };
    const saveForm = async (
      jumpOtherValid,
      params,
      btnText,
    ) => {
      try {
        let values = isShowForm ? await formRef.current.validate() : {};
        let formdata = { ...formData, ...values, ...params };
        if (dynamicGetChildrenData) {
          //动态获取子tab的数据-需要再tab上设置key
          let childrenData = {};
          if (Array.isArray(children)) {
            childrenData = {
              ...childrenData,
              ...formatChildren(children),
            };
          } else {
            childrenData = {
              ...childrenData,
              ...formatChildren(
                children?.props?.children &&
                  Array.isArray(children?.props?.children)
                  ? children?.props?.children
                  : children
              ),
            };
          }
          let resChildrenData = {};
          for (const key in childrenData) {
            if (childrenData[key]) {
              resChildrenData[key] = childrenData[key];
            }
          }
          formdata = {
            ...formdata,
            ...resChildrenData,
          };
        }
        if (!jumpOtherValid) {
          let errOther =
            otherValidate && otherValidate(formdata, btnText);
          if (errOther) {
            Notification.warning({
              title: t('t_remind'),
              content: errOther,
              showIcon: true,
              position: 'bottomRight',
              duration: 1500,
            });
            return;
          }
        }
        if (formdata[keyField] || forceUpdate) {
          let params = getUpdateInput
            ? await getUpdateInput(formdata, btnText, {})
            : formdata;
          await updateDataAsync(
            params,
            btnText
          );
        } else {
          let params = getCreateInput
            ? await getCreateInput(formdata, btnText, {})
            : formdata;
          await createDataAsync(
            params,
            btnText
          );
        }
      } catch (error) {
        console.log(error, 'saveFormError');

        let msgContent = [];
        if (error?.errors) {
          for (let key in error.errors) {
            const err = error.errors[key];
            let resFormItem = formItem.length
              ? formItem
              : formRef?.current?.getFormItem();
            const item = findFormItem(resFormItem, key);
            msgContent.push(
              <p>{(item ? item.label : key) + ':' + err.message}</p>
            );
          }
        }
        if (msgContent.length == 0)
          msgContent = defaultMsgContent
            ? t('t_formError')
            : error.error.message;
        Notification.error({
          title: t('t_remind'),
          content: msgContent,
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        });
      }
    };
    const resetForm = () => {
      if (formRef && formRef.current) {
        formRef?.current?.resetForm();
      }
    };
    const resetformAndCancel = () => {
      if (formRef && formRef.current) {
        type != 'div' && formRef?.current?.resetForm();
      }
      onCancel && onCancel();
      setShowSidePanel(false);
      setActiveTab('0');
    };
    const renderExistConfirm = () => (
      <CommonConfirm
        title={t('t_remind')}
        content={t('t_form_change_content')}
        isVisible={showExistConfirm}
        onConfirm={() => {
          setShowExistConfirm(false);
          resetformAndCancel();
        }}
        confirmText={t('b_confirm')}
        onCancel={() => setShowExistConfirm(false)}
      />
    );
    const cancel = (noRemind = false) => {
      if (formRef && formRef.current) {
        const changeStatus = formRef.current.getChangeStatus();
        if (changeStatus && !noRemind) {
          setShowExistConfirm(true);
        } else {
          resetformAndCancel();
        }
      } else {
        resetformAndCancel();
      }
    };
    const showAndSwitchTab = (tabIndex) => {
      setShowSidePanel(true);
      setActiveTab(tabIndex);
      onTabChange && onTabChange(tabIndex);
    };
    useEffect(() => {
      if (!isMounted()) return;
      if (event) {
        switch (event.name) {
          case 'cancel':
            cancel(true);
            break;
          case 'setShowSidePanel':
            setShowSidePanel(...event.params);
            event.callback && event.callback();
            break;
          case 'showAndSwitchTab':
            let tabidx = event.params[0];
            tabidx =
              tabidx === '0' &&
                activeTabIndex !== undefined &&
                tabidx !== activeTabIndex
                ? activeTabIndex
                : tabidx;
            showAndSwitchTab(tabidx);
            event.callback && event.callback();
            break;
          case 'resetForm':
            resetForm();
            event.callback && event.callback(initData);
            break;
          case 'changeData':
            setNewFormData({ ...formData, ...event.params });
            event.callback && event.callback();
            break;
          case 'saveFormJumpOtherValid':
            saveForm(true).then(() => {
              event.callback && event.callback();
            });
            break;
          default:
            break;
        }
      }
    }, [event]);
    useEffect(() => {
      if (activeTabIndex !== undefined) setActiveTab(activeTabIndex);
    }, [activeTabIndex]);
    const validate = () => {
      return formRef.current.validate();
    };
    const validateErrorInfo = async () => {
      try {
        let values = await formRef.current.validate();
      } catch (error) {
        let msgContent = [];
        if (error?.errors) {
          for (let key in error.errors) {
            const err = error.errors[key];
            const item = findFormItem(formItem, key);
            msgContent.push(
              <p>
                {(item ? t(item.label) ?? item.label : key) + ':' + err.message}
              </p>
            );
          }
        }
        if (msgContent.length == 0) msgContent = t('t_formError');
        throw { message: msgContent };
      }
    };
    const validField = (fieldName, value) => {
      formRef.current.validField(fieldName, value);
    };
    const changIsSumbiting = (flag) => {
      setIsSumbiting(flag);
    };
    const getFormData = () => {
      return newFormData;
    };
    useImperativeHandle(ref, () => ({
      setShowSidePanel,
      showAndSwitchTab,
      resetForm,
      validate,
      validateErrorInfo,
      validField,
      changIsSumbiting,
      getFormData,
    }));
    useEffect(() => {
      if (!isMounted()) return;
      const getDataByIdAsync = async (id, formData) => {
        try {
          setNewFormData({
            ...formData,
          });
        } catch (e) {
          Notification.warning({
            title: t('t_remind'),
            content: t('t_errorToReadData'),
            showIcon: true,
            position: 'bottomRight',
          });
        } 
      };
      if (id || formData) {
        getDataByIdAsync(id, formData);
      }
      if (!formData) setNewFormData(initData || {});
    }, [id, formData]);
    const _onTabChange = (key) => {
      setActiveTab(key);
      onTabChange && onTabChange(key);
    };
    const onKeyUp = (e) => {
      if (e?.altKey === true && e?.key === 's' && isQuickSave) {
        //ALT+S保存
        saveForm();
      }
    };
    const commonForm = (
      <CommonForm
        sizeClass={sizeClass}
        initData={initData}
        newFormData={newFormData}
        formItem={formItem}
        ref={formRef}
        rules={rules}
        onChange={onChange}
        onChangeBefore={onChangeBefore}
        disabled={disabled || formDisabled}
        render={render}
        layout={layout}
        labelCol={labelCol}
        wrapperCol={wrapperCol}
      ></CommonForm>
    );
    //主页签
    const mainTab = (
      <div
        style={{
          // height:
          //   type == 'div'
          //     ? undefined
          //     : height
          //     ? height + (showHead ? 0 : 0) + 'px'
          //     : clientHeight - 190 + 'px',
          overflow: showHead ? undefined : 'auto',
          padding: '5px',
          // border: showHead ? undefined : "1px solid #bababa",
        }}
        onKeyDown={onKeyUp}
        tabIndex={-1}
      >
        {commonForm}
        {bottomSlot}
      </div>
    );
    const getTitle = (title) => {
      return (
        <div style={{ display: 'flex' }}>
          <div className="card-head-flag"></div>
          <span>{title}</span>
        </div>
      );
    };

    const getChildrenCardItem = () => (
      <Spin loading={loading} style={{ display: 'block' }}>
        <div
          style={{
            height: (height ?? clientHeight - 10) - 120 + 'px',
            overflow: 'auto',
          }}
        >
          <div id={mainDivIdField}></div>
          {children ? (
            <div>
              {isShowForm && (
                <Card
                  bordered={false}
                  key="0"
                  title={showHead && title ? getTitle(title) : undefined}
                  size="small"
                >
                  {formCardBtnLayout === 'top' ? (
                    <div style={formCardBtnLayoutStyle}>
                      {renderBottomButtons()}
                    </div>
                  ) : (
                    <></>
                  )}
                  {commonForm}
                  {formCardBtnLayout === 'bottom' ? (
                    <div style={formCardBtnLayoutStyle}>
                      {renderBottomButtons()}
                    </div>
                  ) : (
                    <></>
                  )}
                </Card>
              )}
              {Children.map(children, (child, index) => {
                if (!child) return;
                let title = child.props['title'];
                let divId = child.props['id'];
                return (
                  <Card
                    id={divId}
                    bordered={false}
                    key={1 + index}
                    title={title ? getTitle(title) : undefined}
                    size="small"
                  >
                    {cloneElement(child, {
                      title: '',
                      disabled,
                    })}
                  </Card>
                );
              })}
            </div>
          ) : showHead ? (
            <Card title={getTitle(title)} bordered={false} size="small">
              {mainTab}
            </Card>
          ) : (
            mainTab
          )}
        </div>
      </Spin>
    );
    const getChildrenTabItem = () =>
      children ? (
        <Tabs
          style={{
            height: height ? height + 60 + 'px' : clientHeight - 125 + 'px',
            overflow: 'scroll',
          }}
          type="card-gutter"
          size={sizeClass}
          activeTab={activeTab}
          onChange={_onTabChange}
          lazyload={lazyLoad}
        >
          {isShowForm && (
            <TabPane key="0" title={title} style={{ overflowY: 'auto' }}>
              {mainTab}
            </TabPane>
          )}
          {Children.map(children, (child, index) => {
            if (!child) return;
            let title = child.props['title'];
            let uninstallTitle = child.props['data-uninstallTitle'] || false;
            if (!title && !uninstallTitle) return;
            return (
              <TabPane title={title} style={{ overflowY: 'auto' }}>
                {cloneElement(child, {
                  title: '',
                })}
              </TabPane>
            );
          })}
        </Tabs>
      ) : showHead ? (
        <Tabs
          style={{
            height: height ? height + 60 + 'px' : clientHeight - 140 + 'px',
          }}
          type="card-gutter"
          size={sizeClass}
          activeTab={activeTab}
          onChange={_onTabChange}
          lazyload={lazyLoad}
        >
          <TabPane key="0" title={title} style={{ overflowY: 'auto' }}>
            {mainTab}
          </TabPane>
        </Tabs>
      ) : (
        mainTab
      );
    const renderOtherButton = () => {
      const x = [' '];
      let i = 0;
      for (const key in otherButtons) {
        if (!otherButtons[key]) continue;
        i++;
        x.push(
          <React.Fragment key={i}>
            <Button
              style={{ marginRight: '5px' }}
              type={otherButtons[key].type || 'default'}
              status={otherButtons[key].status || 'primary'} //'warning' | 'danger' | 'success' | 'default'
              size={sizeClass}
              icon={otherButtons[key].icon}
              disabled={otherButtons[key].disabled}
              onClick={otherButtons[key].onClick}
              loading={otherButtons[key].isLoading ?? otherButtons[key].loading}
              tabIndex={1}
            >
              {otherButtons[key].text}
            </Button>
          </React.Fragment>
        );
      }
      return x;
    };
    const renderBottomButtons = () => (
      <div
        style={{
          display: 'flex',
          // paddingTop: '5px',
          justifyContent: 'right',
        }}
      >
        {otherButtons && renderOtherButton()}
        {!disabled &&
          (showSaveButton === undefined || showSaveButton === true) && (
            <Button
              style={{ marginRight: '8px' }}
              icon={saveIcon}
              type="primary"
              size={sizeClass}
              onClick={async () => {
                saveForm(
                  false,
                  {},
                  saveTextCallback
                    ? saveTextCallback()
                    : saveText
                      ? saveText
                      : t('b_save')
                );
              }}
              loading={isSumbiting}
              disabled={loading || canSaveDisabled}
              tabIndex={1}
            >
              {saveText ? saveText : t('b_save')}
            </Button>
          )}
        {(showCancelButton === undefined || showCancelButton === true) && (
          <Button
            icon={<IconPoweroff />}
            type="default"
            size={sizeClass}
            onClick={cancel}
            tabIndex={1}
          >
            {returnText ? returnText : t('b_return')}
          </Button>
        )}
      </div>
    );
    const renderChildren = () => {
      //currentFormLayout = 'tabs', //表单显示模式: "tabs" | "card" ,默认:tabs
      if (currentFormLayout == 'tabs') {
        return getChildrenTabItem();
      } else {
        return getChildrenCardItem();
      }
    };
    const getPannelTitle = () => {
      const panneltitle = showHead ? panelTitle : panelTitle ?? title;
      return panneltitle
        ? panneltitle +
        (disabled
          ? ''
          : showTitleType
            ? '——' + (id ? t('t_titleEdit') : t('t_titleAdd'))
            : '')
        : disabled
          ? t('t_titleShowData')
          : id
            ? t('t_titleEditData')
            : t('t_titleAddData');
    };
    const renderSidePanel = () => (
      <Drawer
        autoFocus
        focusLock
        escToExit={escToExit}
        maskClosable={closeOnClickBackground}
        width={width}
        title={<span>{getPannelTitle()}</span>}
        visible={showSidePanel}
        onCancel={() => cancel()}
        footer={renderBottomButtons()}
      >
        <div>{renderChildren()}</div>
      </Drawer>
    );
    const renderModal = () => (
      <Modal
        title={getPannelTitle()}
        visible={showSidePanel}
        footer={renderBottomButtons()}
        onCancel={() => cancel()}
        style={{ width: width + 'px' }}
        maskClosable={closeOnClickBackground}
        closable={true}
        escToExit={escToExit}
        focusLock
        autoFocus
        onMouseOver={() => {
          draggable && draggableDisabled && setDraggableDisabled(false);
        }}
        onMouseOut={() => {
          draggable && !draggableDisabled && setDraggableDisabled(true);
        }}
        modalRender={
          draggable
            ? (modal) => (
              <Draggable disabled={draggableDisabled}>{modal}</Draggable>
            )
            : undefined
        }
      >
        {renderChildren()}
      </Modal>
    );
    const renderDiv = () => (
      // <Spin loading={loading} style={{ display: 'block' }}>
      <div className={className}>
        {renderChildren()}
        {formCardBtnLayout === 'footer' ? (
          <div className="form-div-footer">{renderBottomButtons()}</div>
        ) : (
          <></>
        )}
      </div>
      // </Spin>
    );
    return (
      <div>
        {/* <Spin loading={loading} style={{ display: 'block' }}> */}
        {(type === undefined || type === 'sidePanel') && renderSidePanel()}
        {type === 'div' && renderDiv()}
        {type === 'dialog' && renderModal()}
        {renderExistConfirm()}
        {/* </Spin> */}
      </div>
    );
  }
);

